/**
 * Utility functions for image handling and URL prioritization
 */

/**
 * Get the best available image URL with prioritization
 * @param {Object} image - Image object from API
 * @param {boolean} preferLarge - Whether to prefer large images over thumbnails
 * @returns {string} - Best available image URL
 */
export const getImageUrl = (image, preferLarge = false) => {
  if (!image) {
    return preferLarge ? '/api/placeholder/400/400' : '/api/placeholder/150/150';
  }

  if (preferLarge) {
    // For modal/large display, prefer larger, high-quality images
    return (
      image.signed_url ||
      image.file ||
      image.thumbnail_signed_url ||
      image.thumbnail_file ||
      image.signed_image_url ||
      image.image_url ||
      image.thumbnail_url ||
      '/api/placeholder/400/400'
    );
  } else {
    // For thumbnails, prefer smaller images
    return (
      image.thumbnail_signed_url ||
      image.signed_url ||
      image.thumbnail_file ||
      image.file ||
      image.signed_thumbnail_url ||
      image.signed_image_url ||
      image.thumbnail_url ||
      image.image_url ||
      '/api/placeholder/150/150'
    );
  }
};

/**
 * Get fallback image URL from mole data
 * @param {Object} mole - Mole object
 * @returns {string} - Fallback image URL
 */
export const getFallbackImageUrl = (mole) => {
  return mole?.identification_thumbnail_url || '/api/placeholder/150/150';
};
